enum OrderStatus {
	PREPARING = 'PREPARING', 
	CANCELLED = 'CANCELLED', 
	DELIVERED = 'DELIVERED'
}

export default OrderStatus;